<nav class="nav-filters">
  <div class="search-content">
    <form class="search-form" (submit)="search()">
      <div class="search-wrapper wrapper-left">
        <div class="search-input search-text only-input">
          <label>{{ getSearchLabel() }}</label>
          <input
            placeholder="{{ getPlaceholderForSearch() }}"
            type="text"
            name="search-string"
            [(ngModel)]="searchParams.name">
        </div>

        <div class="search-category types" *ngIf="accountType === 'company'">
          <div class="open-drop" (click)="showCategoryFilter=!showCategoryFilter"
               [class.active-drop]="showCategoryFilter">
            <p><b>Categoria</b></p>
          </div>

          <div class="drop-items category-items" [class.active-drop]="showCategoryFilter">
            <ul>
              <ng-container *ngFor="let category of categories">
                <li class="colab-checkbox" [class.checked]="category.checked">
                  <ul>
                    <li>
                      <input
                        class="input-category"
                        type="checkbox"
                        [name]="category.name"
                        [id]="category.id"
                        [(ngModel)]="category.checked"
                        (change)="onSelectCategory(category)">
                      <label class="input-category-label" [for]="category.id">
                        {{ category.name }}
                      </label>
                      <span class="arrow" (click)="toggleCategory(category)" [class.open]="category.showSubcategories"></span>
                    </li>
                  </ul>
                  <ul class="subcategory-list" [class.expanded]="category.showSubcategories" [style.height.px]="category.showSubcategories ? category.subcategories.length * 30 : 0">
                    <ng-container *ngFor="let subcategory of category.subcategories">
                      <li>
                        <input
                          class="input-category"
                          type="checkbox"
                          [name]="subcategory.name"
                          [id]="subcategory.id"
                          [(ngModel)]="subcategory.checked"
                          (change)="updateCategoriesSearchParam()">
                        <label class="input-category-label" [for]="subcategory.id">{{ subcategory.name }}</label>
                      </li>
                    </ng-container>
                  </ul>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>

      <div class="search-wrapper wrapper-right" *ngIf="accountType === 'company'">
        <div class="search-input only-input-check colab-checkbox">
          <input
            type="checkbox"
            name="online"
            id="onlineSearch"
            [(ngModel)]="searchType.online">
          <label for="onlineSearch">Online</label>
        </div>

        <div class="search-category" [class.disabled]="!addresses.length && !currentLocation">

          <div class="search-input only-input-check colab-checkbox">
            <input
              type="checkbox"
              name="nearSearch"
              id="nearSearch"
              (change)="onChangeSearchType()"
              [(ngModel)]="searchType.near">
            <label for="nearSearch">Perto de</label>
          </div>

          <div class="open-drop" [class.active-drop]="showLocationFilter"
               (click)="showLocationFilter=!showLocationFilter">
            <div class="selected-items one-item">
              <ul>
                <li><p>{{searchType.nearSearchLabel}}</p></li>
              </ul>
            </div>

          </div>
          <div class="drop-items location-items" [ngClass]="{'active-drop': showLocationFilter}">

            <mapbox-search
              [searchType]="searchType"
              [searchParams]="searchParams"
              [currentLocation]="currentLocation"
              (search)="search()"
            ></mapbox-search>

            <h4 class="title-drop" *ngIf="!searchType.fromLocationSearch"><span class="fa fa-map-marker"></span>{{locationLabel}}</h4>
            <ul class="max-items" *ngIf="!searchType.fromLocationSearch">
              <li class="colab-radio" [class.disabled]="!currentLocation">
                <input
                  type="radio"
                  name="location"
                  id="myLocal"
                  [value]="currentLocation"
                  (change)="onSelectLocation(currentLocation)"
                  [(ngModel)]="searchParams.location"/>
                <label for="myLocal">Minha localização</label>
              </li>
              <li class="colab-radio" *ngFor="let address of addresses">
                <input
                  type="radio"
                  name="location"
                  id="{{address.id}}"
                  value="{{address.location.lat}},{{address.location.lng}}"
                  [checked]="isAddressChecked(address)"
                  (change)="onSelectLocation($event.target.value)"/>
                <label for="{{address.id}}">{{address.nameUnit}}</label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <button [disabled]="loading" type="submit" tabindex="1" class="input-find-search">
        <span class="fa fa-search"></span>
      </button>
    </form>
  </div>
</nav>
